const AuthMass=[
    {
        id:1,
        title:"Капітан Пунш 250мл",
        price:"220 грн",
        src: require('../img/kapitanPonsh.png'),
        text:` ром голд, сік лайму, сік апелсин, сік ананас, сироп гренадин`,
 isNew: true,
//  isHalloween: true
    },
//     {
//         id:2,
//         title:"blacked 200мл",
//         price:"190 грн",
//         src: require('../img/blacked.png'),
//         text:` джин,
// Лікер смородина,
// сироп малина,
// сік лимона`,
//  isNew: true,
//  isHalloween: true
//     },
    {
        id:3,
        title:"Creamy pumpkin 250мл",
        price:"240 грн",
        src: require('../img/Creamypumpkin.png'),
        text:` Бурбон,
Тиква,
Лікер Амарето,
Вершки`,
 isNew: true,
//  isHalloween: true
    },
//     {
//         id:4,
//         title:"Dark days 350мл",
//         price:"200 грн",
//         src: require('../img/Darkdays.png'),
//         text:` Золотий ром,
// Лікер дині,
// Сік яблока,
// Гренадин`,
//  isNew: true,
//  isHalloween: true
//     },
    {
        id:5,
        title:"Oranjini 250мл",
        price:"230 грн",
        src: require('../img/Oranjini.png'),
        text:` Jägermeister  orange,
Campari,
Crème de casis`,
 isNew: true,
    },
{
        id:6,
        title:"Оранж тонік 250мл",
        price:"220 грн",
        src: require('../img/orangeTonic.png'),
        text:`Jägermeister orange, 
Тонік,
Апельсин`,
 isNew: true,
    },
{
        id:7,
        title:"Portokali 250мл",
        price:"245 грн",
        src: require('../img/Portokali.png'),
        text:`Jägermeister orange, 
Crème de casis,
Сік яблучний,
7ап`,
 isNew: true,
    },
{
        id:8,
        title:"Orange fam 250мл",
        price:"220 грн",
        src: require('../img/Orangefam.png'),
        text:`Jägermeister orange, 
Cointreau, 
Апельсин, 
7ап`,
 isNew: true,
    },

    {
        id:9,
        title:"Файний джин 250мл",
        price:"220 грн",
        src: require('../img/fayniyjin.png'),
        text:"гордон`c середземноморський апельсин, тонік, апельсин",
    },
    
    {
        id:10,
        title:"Пекельна мала 350мл",
        price:"220 грн",
        src: require('../img/pekelnamala.png'),
        text:"гордон`c середземноморський апельсин, лимонний сік, сироп гренадін",
    },
    {
        id:11,
        title:"Німецька ніч 350мл",
        price:"230 грн",
        src: require('../img/noch.webp'),
        text:"ром золотий, jagermaister, амарето лікер, сік лимона, cахарний сироп, пепсі ",
    },
    {
        id:12,
        title:"Жіноча спокуса 350мл",
        price:"215 грн",
        src: require('../img/spokusa.webp'),
        text:"ром золотий, самбука, сік персиковий, сік ананасовий",
    },
    {
        id:13,
        title:"Азія мінор айс ті 450мл",
        price:"240 грн",
        src: require('../img/azia.webp'),
        text:"горілка, ром золотий, джин, лікер диня, сік лимона, 7up",
    },
    {
        id:14,
        title:"Оргазм Тарзана 350мл",
        price:"210 грн",
        src: require('../img/org.webp'),
        text:"горілка, лікер динний, сироп блю кюрасао, сік ананасовий",
    },
    // {
    //     id:15,
    //     title:"Фрізі ківі 450мл",
    //     price:"180 грн",
    //     src: require('../img/kivi.webp'),
    //     text:"горілка, сироп ківі, м’ята, лайм, тонік",
    // },
    // {
    //     id:16,
    //     title:"Краще, ніж секс 120мл",
    //     price:"180 грн",
    //     src: require('../img/sex.webp'),
    //     text:"самбука, лікер кавовий, морозиво, молоко",
    // },
    // {
    //     id:17,
    //     title:"Персиковий лизун 350мл",
    //     price:"170 грн",
    //     src: require('../img/liz.webp'),
    //     text:"горілка, сік лимонний, сік персиковий, сироп персиковий, тонік",
    // },
    // {
    //     id:18,
    //     title:"Зелена смерть 450мл",
    //     price:"220 грн",
    //     src: require('../img/smer.webp'),
    //     text:"абсент, горілка, лікер м’ятний, тонік, лимнонний фреш",
    // },
    // {
    //     id:19,
    //     title:"Cherry Valley 350мл",
    //     price:"180 грн",
    //     src: require('../img/granma.webp'),
    //     text:"горілка, сік вишневий, морс із журавлини, сироп гранатовий, тонік",
    // },
    
    {
        id:20,
        title:"Дамський Угодник 450мл",
        price:"230 грн",
        src: require('../img/dam.webp'),
        text:"горілка, сироп кокосовий, сироп мараскіновий, сік вишневий, ред бул",
    },
    {
        id:21,
        title:"Зелена фея 450мл",
        price:"240 грн",
        src: require('../img/fea.webp'),
        text:"горілка, ром золотий, лікер динний, ред бул",
    },
    {
        id:22,
        title:"Ginny Bull 450мл",
        price:"215 грн",
        src: require('../img/tropic.png'),
        text:"джин гордонс, сироп бузина, ред бул тропічний",
    },
    {
        id:23,
        title:"Tropical Hurricane 450мл",
        price:"235 грн",
        src: require('../img/tropic.png'),
        text:"ром золотий, лікер кокосовий, сироп ананасовий, ред бул тропічний",
    },
    
]

export default AuthMass;